export { default as ShipmentInfoListTemplate } from './ShipmentInfoListTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-info/pages/index.js